import { MarketCapCategory, MarketCapData } from '../../lib/models/fundamental/types';

import {
  MARKET_CAP_CATEGORY_OPTIONS,
  MarketCapCategoryOption,
  MarketCapSortDirection,
  MarketCapSortField,
} from './MarketCapRadar.constants';

export const getMarketCapCategoryOption = (category: MarketCapCategory): MarketCapCategoryOption =>
  MARKET_CAP_CATEGORY_OPTIONS.find(option => option.category === category) ?? MARKET_CAP_CATEGORY_OPTIONS[0];

export const getMarketCapCategoryLabel = (category: MarketCapCategory): string =>
  getMarketCapCategoryOption(category).label;

/** Identity of a row - the same symbol can be listed by more than one exchange. */
export const getMarketCapRowKey = (item: MarketCapData): string =>
  `${item.symbol}-${item.stockExchangeCode ?? ''}`;

/** Which sort arrow a header column shows: its own direction, or none when another column sorts. */
export const getMarketCapSortState = (
  field: MarketCapSortField,
  sortField: MarketCapSortField | null,
  sortDirection: MarketCapSortDirection,
): MarketCapSortDirection | null => (field === sortField ? sortDirection : null);
